import React, { useContext } from 'react';
import { Link } from 'react-router-dom';
import SVG from 'react-inlinesvg';
import ConfigContext from '../../../contexts/ConfigContext';

import styles from './QuoteCta.module.postcss';

function QuoteCta() {
  const { city_name, vehicle_type } = useContext(ConfigContext);

  return (
    <div className={styles.QuoteCta}>
      <div className={styles.QuoteCta_inner}>
        <SVG
          src='/static/images/catering-banner-logo.svg'
          width='48'
          height='48'
        />
        <div className='u-strong'>Free No-Obligation Quotes from {city_name}&#39;s Best Food {vehicle_type}s!</div>
      </div>
      <Link to='/catering/register' className='Button'>
        Get Started
      </Link>
    </div>
  );
}

export default QuoteCta;
